// extracted by mini-css-extract-plugin
export var scrollBtn = "ScrollButton-module--scroll-btn--2hglw";